export default "__VITE_ASSET__XeMxfwJU__"